<template>
  <div class="local-baserow-adhoc-header__container">
    <div class="local-baserow-adhoc-header">
      <div class="local-baserow-adhoc-header__item">
        <ViewFilter
          v-if="filterableFields.length"
          read-only
          :view="view"
          :fields="filterableFields"
          :database="database"
          :disable-filter="false"
          @changed="handleFiltersChange"
        ></ViewFilter>
      </div>
      <div class="local-baserow-adhoc-header__item">
        <ViewSort
          v-if="sortableFields.length"
          read-only
          :view="view"
          :fields="sortableFields"
          :database="database"
          @changed="handleSortingsChange"
        ></ViewSort>
      </div>
      <div class="flex-grow-1" />
      <div class="local-baserow-adhoc-header__item">
        <ViewSearch
          v-if="searchableFields.length"
          read-only
          always-hide-rows-not-matching-search
          :view="view"
          :fields="searchableFields"
          @refresh="handleSearchChange"
        ></ViewSearch>
      </div>
    </div>
  </div>
</template>

<script>
import ViewFilter from '@baserow/modules/database/components/view/ViewFilter'
import ViewSort from '@baserow/modules/database/components/view/ViewSort'
import ViewSearch from '@baserow/modules/database/components/view/ViewSearch'
import { getFilters, getOrderBy } from '@baserow/modules/database/utils/view'
import { GridViewType } from '@baserow/modules/database/viewTypes.js'
import { CollaborativeViewOwnershipType } from '@baserow/modules/database/viewOwnershipTypes.js'

export default {
  components: { ViewSearch, ViewSort, ViewFilter },
  props: {
    /**
     * An array of filterable, sortable and searchable *schema* properties.
     * To access the Origem Flow field response, these need to be reduced down
     * to just their `metadata`. This happens in the `computed` methods below.
     */
    filterableProperties: {
      type: Array,
      required: true,
    },
    sortableProperties: {
      type: Array,
      required: true,
    },
    searchableProperties: {
      type: Array,
      required: true,
    },
  },
  emits: ['filters-changed', 'search-changed', 'sortings-changed'],
  data() {
    return {
      view: {
        type: GridViewType.getType(),
        ownership_type: CollaborativeViewOwnershipType.getType(),
        filters: [],
        sortings: [],
        filter_groups: [],
        filter_type: 'AND',
        filters_disabled: false,
        _: { loading: false, type: 'grid' },
      },
      database: {
        workspace: { id: 0 },
      },
    }
  },
  computed: {
    filterableFields() {
      return this.filterableProperties.map((prop) => prop.metadata)
    },
    sortableFields() {
      return this.sortableProperties.map((prop) => prop.metadata)
    },
    searchableFields() {
      return this.searchableProperties.map((prop) => prop.metadata)
    },
  },
  methods: {
    handleFiltersChange() {
      this.$emit('filters-changed', getFilters(this.view, true))
    },
    handleSortingsChange() {
      this.$emit('sortings-changed', getOrderBy(this.view, true))
    },
    handleSearchChange(value) {
      this.$emit('search-changed', value.activeSearchTerm)
    },
  },
}
</script>
